export const DEFAULT_HIGHLIGHT_PROMPT = "As you read, highlight two sentences "
export const BECAUSE = 'because';
export const BUT = 'but';
export const SO = 'so';
export const READ_PASSAGE_STEP_NUMBER = 1
export const BECAUSE_PASSAGE_STEP_NUMBER = 2
export const BUT_PASSAGE_STEP_NUMBER = 3
export const SO_PASSAGE_STEP_NUMBER = 4

export const EVIDENCE = 'evidence';
export const CONNECT = 'connect';
export const DIAGNOSTIC = 'diagnostic';
export const GRAMMAR = 'grammar';
export const LESSONS = 'lessons';
export const PROOFREADER = 'proofreader';
export const TURK = 'turk';

export const CURRICULUM = 'curriculum';
export const PARTNERSHIPS = 'partnerships';
export const PRODUCT = 'product';
export const SUPPORT = 'support';
export const TRANSLATIONS = 'translations';
export const TEAMS = [CURRICULUM, PARTNERSHIPS, PRODUCT, SUPPORT];

export const ARCHIVED_FLAG = 'archived'
export const PRODUCTION_FLAG = 'production'
export const ALPHA_FLAG = 'alpha'
export const BETA_FLAG = 'beta'
export const GAMMA_FLAG = 'gamma'
export const PRIVATE_FLAG = 'private'

export const NOT_APPLICABLE = 'N/A'

export const STUDENT = 'student'
export const TEACHER = 'teacher'
export const INDIVIDUAL_CONTRIBUTOR = 'individual-contributor'
export const ADMIN = 'admin'

export const NOT_LISTED = 'not listed'
export const NO_SCHOOL_SELECTED = 'no school selected'
export const US_HIGHER_ED_SCHOOL_NAME = 'us higher ed'
export const INTERNATIONAL_SCHOOL_NAME = 'international'
export const HIGHER_ED_OR_INTERNATIONAL_SCHOOL = [US_HIGHER_ED_SCHOOL_NAME, INTERNATIONAL_SCHOOL_NAME]
export const COLLEGE_NOT_LISTED = 'college not listed'
export const COLLEGE_NO_SCHOOL_SELECTED = 'college no school selected'
export const PLACEHOLDER_SCHOOL_NAMES = [NOT_LISTED, NO_SCHOOL_SELECTED, COLLEGE_NOT_LISTED, COLLEGE_NO_SCHOOL_SELECTED]
export const COLLEGE_INSTITUTION_TYPE = 'college'
export const US_COLLEGE_SCHOOL_TYPE = 'U.S. College Institution'
export const US_HIGHER_ED_SCHOOL_TYPE = 'U.S. higher education institution'
export const US_K12_SCHOOL_TYPE = 'U.S. K-12 school'

export const SKIPPED = 'Skipped'
export const PENDING = 'Pending'
export const APPROVED = 'Approved'
export const DENIED = 'Denied'

export const EVIDENCE_HANDBOOK_LINK = 'https://docsend.com/view/29vcfdqa5aupkmfp'

export const MAX_VIEW_WIDTH_FOR_MOBILE_NAVBAR = 1150

// Sentry
export const SENTRY_DSN = 'https://528794315c61463db7d5181ebc1d51b9@o95148.ingest.sentry.io/210579'

// Evidence teacher preview step consts
export const INTRODUCTION = 'introduction'
export const CHECKLIST = 'checklist'
export const READ_AND_HIGHLIGHT = 'read-and-highlight'

export const ALLOWED_ATTEMPTS = 5

export const INDETERMINATE = 'indeterminate'
export const ACTIVE = 'active'
export const INACTIVE = 'inactive'
export const DISABLED = 'disabled'
export const DEFAULT = 'default'
export const HOVER = 'hover'

export const EXTRA_EXTRA_SMALL_ICON_BASE_SRC = `${window.postbuildEnv.CDN_URL}/images/icons/2xs`
export const EXTRA_SMALL_ICON_BASE_SRC = `${window.postbuildEnv.CDN_URL}/images/icons/xs`
export const SMALL_ICON_BASE_SRC = `${window.postbuildEnv.CDN_URL}/images/icons/s`
export const SMALL_MEDIUM_ICON_BASE_SRC = `${window.postbuildEnv.CDN_URL}/images/icons/sm`
export const LARGE_ICON_BASE_SRC = `${window.postbuildEnv.CDN_URL}/images/icons/l`
export const EXTRA_LARGE_ICON_BASE_SRC = `${window.postbuildEnv.CDN_URL}/images/icons/xl`
export const EXTRA_EXTRA_LARGE_ICON_BASE_SRC = `${window.postbuildEnv.CDN_URL}/images/icons/2xl`

// Connect feedback types
export const REVISE_UNMATCHED = 'revise-unmatched'
export const REVISE_MATCHED = 'revise-matched'
export const CORRECT_MATCHED = 'correct-matched'
export const OVERRIDE = 'override'
export const INCORRECT_CONTINUE = 'incorrect-continue'
export const CONTINUE = 'continue'
export const INSTRUCTIONS = 'instructions'
export const GET_QUESTION_INSTRUCTIONS = 'getQuestion-instructions'
export const DEFAULT_WITH_CUES = 'default-with-cues'
export const DEFAULT_FILL_IN_BLANK = 'default-fill-in-blank'

// assignment flow constants
export const COLLEGE_BOARD_SLUG = 'college-board'
export const PRE_AP_SLUG = 'pre-ap'
export const AP_SLUG = 'ap'
export const SPRING_BOARD_SLUG = 'springboard'

export const SOCIAL_STUDIES_SLUG = 'social-studies'
export const WORLD_HISTORY_1200_TO_PRESENT_SLUG = 'world-history-1200-to-present'
export const WORLD_HISTORY_1750_TO_PRESENT_SLUG = 'world-history-1750-to-present'
export const INTERDISCIPLINARY_SCIENCE = 'interdisciplinary-science'
export const BUILDING_AI_KNOWLEDGE_SLUG = 'building-ai-knowledge'

export const LITERATURE_SLUG = 'literature'
export const FISHTANK_ELA_GRADE_7_SLUG = 'fishtank-ela-grade-7'
export const FISHTANK_ELA_GRADE_8_SLUG = 'fishtank-ela-grade-8'

export const TEKS_SLUG = 'quill-for-texas'
export const THIRD_GRADE_SLUG = 'third-grade'
export const FOURTH_GRADE_SLUG = 'fourth-grade'
export const FIFTH_GRADE_SLUG = 'fifth-grade'
export const SIXTH_GRADE_SLUG = 'sixth-grade'
export const SEVENTH_GRADE_SLUG = 'seventh-grade'
export const EIGHTH_GRADE_SLUG = 'eighth-grade'
export const ENGLISH_I_SLUG = 'english-i'
export const ENGLISH_II_SLUG = 'english-ii'

export const UNIT_TEMPLATE_NAME = 'unitTemplateName'
export const UNIT_TEMPLATE_ID = 'unitTemplateId'
export const UNIT_NAME = 'unitName'
export const ACTIVITY_IDS_ARRAY = 'activityIdsArray'
export const CLASSROOMS = 'classrooms'
export const UNIT_ID = 'unitId'
export const ASSIGNED_CLASSROOMS = 'assignedClassrooms'

export const clearAssignmentFlowLocalStorage = () => {
  [
    UNIT_TEMPLATE_NAME,
    UNIT_TEMPLATE_ID,
    UNIT_NAME,
    UNIT_ID,
    ACTIVITY_IDS_ARRAY,
    CLASSROOMS,
    ASSIGNED_CLASSROOMS,
  ].forEach(key => window.localStorage.removeItem(key))
}
export const CLICKED_ACTIVITY_PACK_ID = 'clickedActivityPackId'
export const CREATE_YOUR_OWN_ID = 'createYourOwn'

export const STARTER_DIAGNOSTIC_UNIT_TEMPLATE_ID = 752
export const STARTER_DIAGNOSTIC_POST_UNIT_TEMPLATE_ID = 753
export const INTERMEDIATE_DIAGNOSTIC_UNIT_TEMPLATE_ID = 754
export const INTERMEDIATE_DIAGNOSTIC_POST_UNIT_TEMPLATE_ID = 755
export const ADVANCED_DIAGNOSTIC_UNIT_TEMPLATE_ID = 641
export const ADVANCED_DIAGNOSTIC_POST_UNIT_TEMPLATE_ID = 642
export const ELL_STARTER_DIAGNOSTIC_UNIT_TEMPLATE_ID = 643
export const ELL_STARTER_DIAGNOSTIC_POST_UNIT_TEMPLATE_ID = 644
export const ELL_INTERMEDIATE_DIAGNOSTIC_UNIT_TEMPLATE_ID = 645
export const ELL_INTERMEDIATE_DIAGNOSTIC_POST_UNIT_TEMPLATE_ID = 646
export const ELL_ADVANCED_DIAGNOSTIC_UNIT_TEMPLATE_ID = 647
export const ELL_ADVANCED_DIAGNOSTIC_POST_UNIT_TEMPLATE_ID = 649
export const COLLEGE_DIAGNOSTIC_UNIT_TEMPLATE_ID = 1062
export const COLLEGE_DIAGNOSTIC_POST_UNIT_TEMPLATE_ID = 1063
export const PRE_AP_WRITINGS_SKILLS_1_UNIT_TEMPLATE_ID = 194
export const PRE_AP_WRITINGS_SKILLS_2_UNIT_TEMPLATE_ID = 195
export const AP_WRITINGS_SKILLS_UNIT_TEMPLATE_ID = 193
export const SPRING_BOARD_SKILLS_UNIT_TEMPLATE_ID = 253

export const STARTER_DIAGNOSTIC_ACTIVITY_ID = 2861
export const INTERMEDIATE_DIAGNOSTIC_ACTIVITY_ID = 2863
export const ADVANCED_DIAGNOSTIC_ACTIVITY_ID = 2541
export const ELL_STARTER_DIAGNOSTIC_ACTIVITY_ID = 2550
export const ELL_INTERMEDIATE_DIAGNOSTIC_ACTIVITY_ID = 2555
export const ELL_ADVANCED_DIAGNOSTIC_ACTIVITY_ID = 2563
export const COLLEGE_DIAGNOSTIC_ACTIVITY_ID = 3505

export const OLD_STARTER_DIAGNOSTIC_2024_ACTIVITY_ID = 2537
export const OLD_INTERMEDIATE_DIAGNOSTIC_2024_ACTIVITY_ID = 2539
export const OLD_STARTER_DIAGNOSTIC_2024_POST_ACTIVITY_ID = 2538
export const OLD_INTERMEDIATE_DIAGNOSTIC_2024_POST_ACTIVITY_ID = 2540

export const OLD_STARTER_DIAGNOSTIC_2023_ACTIVITY_ID = 1663
export const OLD_INTERMEDIATE_DIAGNOSTIC_2023_ACTIVITY_ID = 1668
export const OLD_ADVANCED_DIAGNOSTIC_2023_ACTIVITY_ID = 1678
export const OLD_ELL_STARTER_DIAGNOSTIC_2023_ACTIVITY_ID = 1161
export const OLD_ELL_INTERMEDIATE_DIAGNOSTIC_2023_ACTIVITY_ID = 1568
export const OLD_ELL_ADVANCED_DIAGNOSTIC_2023_ACTIVITY_ID = 1590

export const STARTER_DIAGNOSTIC_POST_ACTIVITY_ID = 2862
export const INTERMEDIATE_DIAGNOSTIC_POST_ACTIVITY_ID = 2864
export const ADVANCED_DIAGNOSTIC_POST_ACTIVITY_ID = 2542
export const ELL_STARTER_DIAGNOSTIC_POST_ACTIVITY_ID = 2551
export const ELL_INTERMEDIATE_DIAGNOSTIC_POST_ACTIVITY_ID = 2557
export const ELL_ADVANCED_DIAGNOSTIC_POST_ACTIVITY_ID = 2564
export const COLLEGE_DIAGNOSTIC_POST_ACTIVITY_ID = 3506


export const starterPreTest = {
  activityId: STARTER_DIAGNOSTIC_ACTIVITY_ID,
  name: 'Starter Diagnostic (Baseline Pre)',
  unitTemplateId: STARTER_DIAGNOSTIC_UNIT_TEMPLATE_ID,
  what: 'Plural nouns, possessive nouns, capitalization, subject-verb agreement, pronouns, and commonly confused words',
  when: 'Your students are working on basic grammar concepts.'
}

export const starterPostTest = {
  activityId: STARTER_DIAGNOSTIC_POST_ACTIVITY_ID,
  name: 'Starter Diagnostic (Growth Post)',
  unitTemplateId: STARTER_DIAGNOSTIC_POST_UNIT_TEMPLATE_ID,
  what: 'The Starter Growth Diagnostic has different questions but covers the same skills as the Starter Baseline Diagnostic.',
  when: "Your students have completed the Starter Baseline Diagnostic, you've assigned the recommended practice, and now you're ready to measure their growth.",
  lockedText: "This is locked because you haven't assigned the Starter Baseline Diagnostic yet. Assign it to unlock the Starter Growth Diagnostic. If you are a co-teacher, please ask the classroom's owner to assign the diagnostics."
}

export const intermediatePreTest = {
  activityId: INTERMEDIATE_DIAGNOSTIC_ACTIVITY_ID,
  name: 'Intermediate Diagnostic (Baseline Pre)',
  unitTemplateId: INTERMEDIATE_DIAGNOSTIC_UNIT_TEMPLATE_ID,
  what: 'Compound subjects, compound objects, compound predicates, simple appositives, compound sentences, complex sentences, compound-complex sentences, and conjunctive adverbs',
  when: 'Your students have practiced the basics of grammar and are ready to develop their sentence construction skills.'
}

export const intermediatePostTest = {
  activityId: INTERMEDIATE_DIAGNOSTIC_POST_ACTIVITY_ID,
  name: 'Intermediate Diagnostic (Growth Post)',
  unitTemplateId: INTERMEDIATE_DIAGNOSTIC_POST_UNIT_TEMPLATE_ID,
  what: 'The Intermediate Growth Diagnostic has different questions but covers the same skills as the Intermediate Baseline Diagnostic.',
  when: "Your students have completed the Intermediate Baseline Diagnostic, you've assigned the recommended practice, and now you're ready to measure their growth.",
  lockedText: "This is locked because you haven't assigned the Intermediate Baseline Diagnostic yet. Assign it to unlock the Intermediate Growth Diagnostic. If you are a co-teacher, please ask the classroom's owner to assign the diagnostics."
}

export const advancedPreTest = {
  activityId: ADVANCED_DIAGNOSTIC_ACTIVITY_ID,
  name: 'Advanced Diagnostic (Baseline Pre)',
  unitTemplateId: ADVANCED_DIAGNOSTIC_UNIT_TEMPLATE_ID,
  what: 'Relative clauses, appositive phrases, participial phrases, parallel structure, and open sentence combining',
  when: 'Your students are experienced with Quill, understand sentence combining, and are ready to develop advanced multi-clause sentences.'
}

export const advancedPostTest = {
  activityId: ADVANCED_DIAGNOSTIC_POST_ACTIVITY_ID,
  name: 'Advanced Diagnostic (Growth Post)',
  unitTemplateId: ADVANCED_DIAGNOSTIC_POST_UNIT_TEMPLATE_ID,
  what: 'The Advanced Growth Diagnostic has different questions but covers the same skills as the Advanced Baseline Diagnostic.',
  when: "Your students have completed the Advanced Baseline Diagnostic, you've assigned the recommended practice, and now you're ready to measure their growth.",
  lockedText: "This is locked because you haven't assigned the Advanced Baseline Diagnostic yet. Assign it to unlock the Advanced Growth Diagnostic. If you are a co-teacher, please ask the classroom's owner to assign the diagnostics."
}

export const collegePreTest = {
  activityId: COLLEGE_DIAGNOSTIC_ACTIVITY_ID,
  name: 'College Diagnostic (Baseline Pre)',
  unitTemplateId: COLLEGE_DIAGNOSTIC_UNIT_TEMPLATE_ID,
  what: 'Academic subject-verb agreement, plural, possessive, & plural possessive nouns, compound sentences, complex sentences, conjunctive adverbs, compound-complex sentences, appositive phrases, and participial phrases',
  when: 'Your college students are working on varying sentence structures and writing with fluidity.'
}

export const collegePostTest = {
  activityId: COLLEGE_DIAGNOSTIC_POST_ACTIVITY_ID,
  name: 'College Diagnostic (Growth Post)',
  unitTemplateId: COLLEGE_DIAGNOSTIC_POST_UNIT_TEMPLATE_ID,
  what: 'The College Growth Diagnostic has different questions but covers the same skills as the College Baseline Diagnostic.',
  when: "Your college students have completed the College Baseline Diagnostic, you've assigned the recommended practice, and now you're ready to measure their growth.",
  lockedText: "This is locked because you haven't assigned the College Baseline Diagnostic yet. Assign it to unlock the College Growth Diagnostic. If you are a co-teacher, please ask the classroom's owner to assign the diagnostics."
}

export const ellStarterPreTest = {
  activityId: ELL_STARTER_DIAGNOSTIC_ACTIVITY_ID,
  name: 'ELL Starter Diagnostic (Baseline Pre)',
  unitTemplateId: ELL_STARTER_DIAGNOSTIC_UNIT_TEMPLATE_ID,
  what: 'Articles, plurals, possessives, pronouns, adjectives, adverbs, negation, questions, and prepositions',
  when: 'Your students are newcomer or beginner English learners working on basic English grammar concepts.'
}

export const ellStarterPostTest = {
  activityId: ELL_STARTER_DIAGNOSTIC_POST_ACTIVITY_ID,
  name: 'ELL Starter Diagnostic (Growth Post)',
  unitTemplateId: ELL_STARTER_DIAGNOSTIC_POST_UNIT_TEMPLATE_ID,
  what: 'The ELL Starter Growth Diagnostic has different questions but covers the same skills as the ELL Starter Baseline Diagnostic.',
  when: "Your students have completed the ELL Starter Baseline Diagnostic, you've assigned the recommended practice, and now you're ready to measure their growth.",
  lockedText: "This is locked because you haven't assigned the ELL Starter Baseline Diagnostic yet. Assign it to unlock the ELL Starter Growth Diagnostic. If you are a co-teacher, please ask the classroom's owner to assign the diagnostics."
}

export const ellIntermediatePreTest = {
  activityId: ELL_INTERMEDIATE_DIAGNOSTIC_ACTIVITY_ID,
  name: 'ELL Intermediate Diagnostic (Baseline Pre)',
  unitTemplateId: ELL_INTERMEDIATE_DIAGNOSTIC_UNIT_TEMPLATE_ID,
  what: 'Simple tenses, progressive tenses, perfect tenses, and modality',
  when: 'Your students are beginner, intermediate, or advanced English learners working on English tenses.'
}

export const ellIntermediatePostTest = {
  activityId: ELL_INTERMEDIATE_DIAGNOSTIC_POST_ACTIVITY_ID,
  name: 'ELL Intermediate Diagnostic (Growth Post)',
  unitTemplateId: ELL_INTERMEDIATE_DIAGNOSTIC_POST_UNIT_TEMPLATE_ID,
  what: 'The ELL Intermediate Growth Diagnostic has different questions but covers the same skills as the ELL Intermediate Baseline Diagnostic.',
  when: "Your students have completed the ELL Intermediate Baseline Diagnostic, you've assigned the recommended practice, and now you're ready to measure their growth.",
  lockedText: "This is locked because you haven't assigned the ELL Intermediate Baseline Diagnostic yet. Assign it to unlock the ELL Intermediate Growth Diagnostic. If you are a co-teacher, please ask the classroom's owner to assign the diagnostics."
}

export const ellAdvancedPreTest = {
  activityId: ELL_ADVANCED_DIAGNOSTIC_ACTIVITY_ID,
  name: 'ELL Advanced Diagnostic (Baseline Pre)',
  unitTemplateId: ELL_ADVANCED_DIAGNOSTIC_UNIT_TEMPLATE_ID,
  what: 'Challenging articles, countable vs. uncountable nouns, challenging pronouns, commonly confused words, gerunds vs. infinitives, -ed vs -ing adjectives, embedded questions, and responding to questions',
  when: 'Your students are upper-intermediate or advanced English learners who understand the basics of English but need practice correcting errors based on transfer from their home language(s) to English.'
}

export const ellAdvancedPostTest = {
  activityId: ELL_ADVANCED_DIAGNOSTIC_POST_ACTIVITY_ID,
  name: 'ELL Advanced Diagnostic (Growth Post)',
  unitTemplateId: ELL_ADVANCED_DIAGNOSTIC_POST_UNIT_TEMPLATE_ID,
  what: 'The ELL Advanced Growth Diagnostic has different questions but covers the same skills as the ELL Advanced Baseline Diagnostic.',
  when: "Your students have completed the ELL Advanced Baseline Diagnostic, you've assigned the recommended practice, and now you're ready to measure their growth.",
  lockedText: "This is locked because you haven't assigned the ELL Advanced Baseline Diagnostic yet. Assign it to unlock the ELL Advanced Growth Diagnostic. If you are a co-teacher, please ask the classroom's owner to assign the diagnostics."
}

export const apWritingSkills = {
  activityId: 992,
  name: 'AP Writing Skills Survey',
  unitTemplateId: AP_WRITINGS_SKILLS_UNIT_TEMPLATE_ID,
  what: 'Compound-complex sentences, appositive phrases, relative clauses, participial phrases, and parallel structure',
  when: 'Your students are developing their advanced sentence-level writing skills to prepare for writing in an AP® classroom.'
}

export const preAPWritingSkills1 = {
  activityId: 1229,
  name: 'Pre-AP Writing Skills Survey 1',
  unitTemplateId: PRE_AP_WRITINGS_SKILLS_1_UNIT_TEMPLATE_ID,
  what: 'Subject-verb agreement, pronouns, and coordinating and subordinating conjunctions',
  when: 'Your students are working on basic sentence patterns and the skills outlined in the Pre-AP® English High School Course Framework.'
}

export const preAPWritingSkills2 = {
  activityId: 1230,
  name: 'Pre-AP Writing Skills Survey 2',
  unitTemplateId: PRE_AP_WRITINGS_SKILLS_2_UNIT_TEMPLATE_ID,
  what: 'Conjunctive adverbs, relative clauses, appositive phrases, participial phrases, and parallel structure',
  when: 'Your students are working on basic sentence patterns and the skills outlined in the Pre-AP® English High School Course Framework.'
}

export const springboardWritingSkills = {
  activityId: 1432,
  name: 'SpringBoard Writing Skills Survey',
  unitTemplateId: SPRING_BOARD_SKILLS_UNIT_TEMPLATE_ID,
  what: 'Subject-verb agreement, pronouns, coordinating and subordinating conjunctions, prepositional phrases, and commonly confused words',
  when: 'Your students are working on basic sentence patterns and the grammar skills covered in the SpringBoard grades 6-8 materials.'
}

export const diagnosticSequences = [
  { label: 'Starter Diagnostic', preTest: starterPreTest, postTest: starterPostTest },
  { label: 'Intermediate Diagnostic', preTest: intermediatePreTest, postTest: intermediatePostTest },
  { label: 'Advanced Diagnostic', preTest: advancedPreTest, postTest: advancedPostTest },
  { label: 'ELL Starter Diagnostic', preTest: ellStarterPreTest, postTest: ellStarterPostTest },
  { label: 'ELL Intermediate Diagnostic', preTest: ellIntermediatePreTest, postTest: ellIntermediatePostTest },
  { label: 'ELL Advanced Diagnostic', preTest: ellAdvancedPreTest, postTest: ellAdvancedPostTest },
  { label: 'College Diagnostic', preTest: collegePreTest, postTest: collegePostTest },
  { label: 'Pre-AP Writing Skills Survey 1', preTest: preAPWritingSkills1 },
  { label: 'Pre-AP Writing Skills Survey 2', preTest: preAPWritingSkills2 },
  { label: 'SpringBoard Writing Skills Survey', preTest: springboardWritingSkills },
  { label: 'AP Writing Skills Survey', preTest: apWritingSkills }
]


export const baselineUnitTemplateIdToGrowthDiagnostic = {
  [starterPreTest.unitTemplateId]: starterPostTest,
  [intermediatePreTest.unitTemplateId]: intermediatePostTest,
  [advancedPreTest.unitTemplateId]: advancedPostTest,
  [ellStarterPreTest.unitTemplateId]: ellStarterPostTest,
  [ellIntermediatePreTest.unitTemplateId]: ellIntermediatePostTest,
  [ellAdvancedPreTest.unitTemplateId]: ellAdvancedPostTest,
  [collegePreTest.unitTemplateId]: collegePostTest,
}

export const postTestClassAssignmentLockedMessages = {
  [STARTER_DIAGNOSTIC_POST_ACTIVITY_ID]: "You can't assign the Starter Growth Diagnostic to this class until you've assigned them the Starter Baseline Diagnostic. If you are a co-teacher, please ask the classroom's owner to assign the diagnostics.",
  [INTERMEDIATE_DIAGNOSTIC_POST_ACTIVITY_ID]: "You can't assign the Intermediate Growth Diagnostic to this class until you've assigned them the Intermediate Baseline Diagnostic. If you are a co-teacher, please ask the classroom's owner to assign the diagnostics.",
  [ADVANCED_DIAGNOSTIC_POST_ACTIVITY_ID]: "You can't assign the Advanced Growth Diagnostic to this class until you've assigned them the Advanced Baseline Diagnostic. If you are a co-teacher, please ask the classroom's owner to assign the diagnostics.",
  [ELL_STARTER_DIAGNOSTIC_POST_ACTIVITY_ID]: "You can't assign the ELL Starter Growth Diagnostic to this class until you've assigned them the ELL Starter Baseline Diagnostic. If you are a co-teacher, please ask the classroom's owner to assign the diagnostics.",
  [ELL_INTERMEDIATE_DIAGNOSTIC_POST_ACTIVITY_ID]: "You can't assign the ELL Intermediate Growth Diagnostic to this class until you've assigned them the ELL Intermediate Baseline Diagnostic. If you are a co-teacher, please ask the classroom's owner to assign the diagnostics.",
  [ELL_ADVANCED_DIAGNOSTIC_POST_ACTIVITY_ID]: "You can't assign the ELL Advanced Growth Diagnostic to this class until you've assigned them the ELL Advanced Baseline Diagnostic. If you are a co-teacher, please ask the classroom's owner to assign the diagnostics.",
  [COLLEGE_DIAGNOSTIC_POST_ACTIVITY_ID]: "You can't assign the College Growth Diagnostic to this class until you've assigned them the College Baseline Diagnostic. If you are a co-teacher, please ask the classroom's owner to assign the diagnostics."
}

export const postTestWarningModalPreNameCorrespondence = {
  [STARTER_DIAGNOSTIC_POST_ACTIVITY_ID]: "Starter Baseline Diagnostic (Pre)",
  [INTERMEDIATE_DIAGNOSTIC_POST_ACTIVITY_ID]: "Intermediate Baseline Diagnostic (Pre)",
  [ADVANCED_DIAGNOSTIC_POST_ACTIVITY_ID]: "Advanced Baseline Diagnostic (Pre)",
  [ELL_STARTER_DIAGNOSTIC_POST_ACTIVITY_ID]: "ELL Starter Baseline Diagnostic (Pre)",
  [ELL_INTERMEDIATE_DIAGNOSTIC_POST_ACTIVITY_ID]: "ELL Intermediate Baseline Diagnostic (Pre)",
  [ELL_ADVANCED_DIAGNOSTIC_POST_ACTIVITY_ID]: "ELL Advanced Baseline Diagnostic (Pre)",
  [COLLEGE_DIAGNOSTIC_POST_ACTIVITY_ID]: "College Baseline Diagnostic (Pre)"
}

export const READING_TEXTS = 'Reading Texts'
export const WHOLE_CLASS_LESSONS = 'Whole Class Lessons'
export const LANGUAGE_SKILLS = 'Language Skills'
export const READING_FOR_EVIDENCE = 'Reading for Evidence'
export const DAILY_PROOFREADING = 'Daily Proofreading'
export const CONNECT_CAPITALIZED = 'Connect'
export const DIAGNOSTIC_CAPITALIZED = 'Diagnostic'
export const GRAMMAR_CAPITALIZED = 'Grammar'
export const PROOFREADER_CAPITALIZED = 'Proofreader'
export const LESSONS_CAPITALIZED = 'Lessons'

export const ACTIVITY_PACK_TYPES = [
  {
    name: 'Reading Texts',
    id: 'reading-texts'
  },
  {
    name: 'Diagnostic',
    id: 'diagnostic'
  },
  {
    name: 'Language Skills',
    id: 'independent-practice',
    types: ['Language Skill Review', 'Language Skills for Writing Genres', 'Language Skills Themed Practice']
  },
  {
    name: 'Proofreading',
    id: 'proofreading',
    types: [DAILY_PROOFREADING]
  },
  {
    name: 'Whole Class Lessons',
    id: 'whole-class'
  },
]

export const DISABLED_DIAGNOSTICS = [
  'Starter Baseline Diagnostic (Pre)',
  'Starter Growth Diagnostic (Post)',
  'Intermediate Baseline Diagnostic (Pre)',
  'Intermediate Growth Diagnostic (Post)',
  'Advanced Baseline Diagnostic (Pre)',
  'Advanced Growth Diagnostic (Post)',
  'ELL Starter Baseline Diagnostic (Pre)',
  'ELL Starter Growth Diagnostic (Post)',
  'ELL Intermediate Baseline Diagnostic (Pre)',
  'ELL Intermediate Growth Diagnostic (Post)',
  'ELL Advanced Baseline Diagnostic (Pre)',
  'ELL Advanced Growth Diagnostic (Post)'
]
